import styled from 'styled-components'

export const LayoutDashboard = styled.div`
  padding: 0 35px 0 40px;
`



// WEBPACK FOOTER //
// ./src/Components/Layout/Dashboard/index.js